import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import lscache from "lscache";

import {SEEN_OFFERS_MAP_KEY} from "../../app/constants/storage_keys";

const readFromStorage = (): number[] => {
    const stored = lscache.get(SEEN_OFFERS_MAP_KEY);
    if (!Array.isArray(stored)) {
        return [];
    }
    return stored.filter((item) => typeof item === "number");
};

export interface ISeenOffersStore {
    ids: number[];
}

const seenOffersSliceInitialState: ISeenOffersStore = {
    ids: []
};

export const seenOffersSlice = createSlice({
    name: "seenOffers",
    initialState: seenOffersSliceInitialState,
    reducers: {
        markOfferAsSeen: (state, action: PayloadAction<number>) => {
            if (state.ids.includes(action.payload)) {
                return;
            }
            state.ids.push(action.payload);
            lscache.set(SEEN_OFFERS_MAP_KEY, state.ids);
        },
        initFromStorage: (state) => {
            state.ids = readFromStorage();
        }
    }
});

export const {markOfferAsSeen, initFromStorage} = seenOffersSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import lscache from "lscache";

import {SEEN_OFFERS_MAP_KEY} from "../../app/constants/storage_keys";

const readFromStorage = (): number[] => {
    const stored = lscache.get(SEEN_OFFERS_MAP_KEY);
    if (!Array.isArray(stored)) {
        return [];
    }
    return stored.filter((item) => typeof item === "number");
};

export interface ISeenOffersStore {
    ids: number[];
}

const seenOffersSliceInitialState: ISeenOffersStore = {
    ids: []
};

export const seenOffersSlice = createSlice({
    name: "seenOffers",
    initialState: seenOffersSliceInitialState,
    reducers: {
        markOfferAsSeen: (state, action: PayloadAction<number>) => {
            if (state.ids.includes(action.payload)) {
                return;
            }
            state.ids.push(action.payload);
            lscache.set(SEEN_OFFERS_MAP_KEY, state.ids);
        },
        initFromStorage: (state) => {
            state.ids = readFromStorage();
        }
    }
});

export const {markOfferAsSeen, initFromStorage} = seenOffersSlice.actions;
